import { createSelector } from '@ngrx/store';
import { AppState } from '../../app-state/app-state';
import { IRepresentedUsersState } from './represented-users.state';

export const getRepresentedUsersState = (state: AppState) => state.representedUsers;

export const getRepresentedUsersCollections = createSelector(getRepresentedUsersState, (state: IRepresentedUsersState) => state.rUsers);

export const getEffectiveUser = createSelector(getRepresentedUsersState, (state: IRepresentedUsersState) => state.effectiveUser);

export const getEffectiveUserIsAdmin = createSelector(getEffectiveUser, (user) => (user ? user.isAdmin() : false));
